import styled from "styled-components";
import ScrollingModal from "../../ScrollingModal";
import { themeProp } from "../../../theme";
import { useMobileMediaQuery } from "../../Responsive";

const ChallengeModal = ({ children, ...props }) => {
  const isMobile = useMobileMediaQuery();

  return (
    <StyledModal className={isMobile ? "mobile" : undefined} {...props}>
      {children}
    </StyledModal>
  );
};

const StyledModal = styled(ScrollingModal)`
  padding: 21px 24px 16px 64px;
  border: 2px solid ${themeProp("palette.primary")};
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(5, 37, 67, 0.15);
  border-radius: 12px;

  &.mobile {
    padding: 16px 16px 16px 16px;
  }
`;

export default ChallengeModal;
